export default __webpack_public_path__ + "static/media/logo.9623f19b.svg";